import CoatOfArms from '@images/bs-coat-of-arms.png'

const TermsOfUse = ({ history }) => {
  return (
    <section className='mx-auto max-w-4xl py-8 lg:py-20'>
      <h1 className='flex justify-center mb-4'>
        <img
          alt='Bhamas Coat of Arms'
          src={CoatOfArms}
          className='w-24 lg:w-40'
        />
      </h1>
      <h2 className='text-center mb-8'>TERMS AND CONDITIONS OF USE</h2>

      <p>
        These Terms and Conditions of Use (referred to as "Terms of Use") apply
        to the MyGateway portal (referred to as the “Portal”). The Portal is the
        centralized secure way to request and pay for government services. The
        Portal is used by clients of the Government of The Bahamas, which
        includes its ministries, departments, and agencies (referred to as the
        “GoBh”) to deliver its services. The Portal is owned by the GoBh and is
        managed, controlled and/or operated by the GoBh and/or its authorized
        contractors. Data and information exchanged and/or stored on the Portal
        resides within the Commonwealth of The Bahamas. You must be at least 18
        years old to use the Portal.
        <br />
        <strong>BY USING THE PORTAL, YOU AGREE TO THESE TERMS OF USE.</strong>
        <br />
        The GoBh reserves the right, at its sole discretion, to change, modify,
        add, or remove portions of these Terms of Use, at any time. It is your
        responsibility to check these Terms of Use periodically for changes. As
        a participant you must read the information below and agree to the terms
        and conditions. Should you choose to use the Portal after a change is
        made this signifies to the GoBh that you agree the changes and indemnify
        the GoBh against any cause of action that may arise. GoBh may modify the
        services on the Portal from time to time, including by adding or
        deleting features and functions, as we continually improve our services,
        the Portal, and the experience we offer You.
      </p>

      <ol className='space-y-8'>
        <li>
          <strong className='block mb-2'>DEFINITIONS</strong>
          <strong>“Terms of Use”</strong>
          means these Terms and Conditions.
          <br />
          <strong>“Confidential Information”</strong>
          means any information obtained from you, the disclosing party, which
          ought reasonably to be considered as confidential and cannot be
          divulged to a third party without your consent provided that this
          clause shall not extend to information (a) which is disclosed or
          obtained lawfully for the purposes of obtaining a service and/or
          completing the necessary process to receive a service provided by the
          GoBh, (b) which is already public knowledge or becomes so at a future
          date (otherwise than as a result of a breach of this clause) (c) which
          is expressly marked as confidential or which is manifestly of a
          confidential nature or which is confirmed in writing to be
          confidential within 7 days of its disclosure.
          <br />
          <strong>“Data”</strong>
          means any data inputted by You into the Portal and the processed data
          that is made available to You as a direct result of Your use of the
          Portal.
          <br />
          <strong>“Disclosing Party”</strong>
          means You, the participant.
          <br />
          <strong>“Government Service”</strong>
          means (and/or includes) the execution of mandatory and procedural
          activities by internal human or system resources which provide
          valuable output requested or required by an individual whether
          personally or on behalf of another person and may also include
          circumstances where the output requested or required is relevant to an
          entity recognized by law.
          <br />
          <strong>“Intellectual Property Right”</strong>
          means any patent, trademark, service mark, copyright, moral right,
          right in a design, know-how and any other intellectual or industrial
          property rights, anywhere in the world whether or not registered.
          <br />
          <strong>“Loss”</strong>
          means all liabilities, expenses, losses, damages, and costs (including
          legal costs) and expenses, however arising.
          <br />
          <strong>“Participant”</strong>
          means You.
          <br />
          <strong>“Portal”</strong>
          means the Internet Portal at the domain{' '}
          <a href='https://mygateway.gov.bs'>https://mygateway.gov.bs</a>.
        </li>

        <li>
          <strong className='block mb-2'>RIGHT OF ACCESS</strong>
          You have the right to access and use the Portal for the intended
          purpose of requesting Government Services and to conduct any matters,
          functions, or processes related thereto. This right is{' '}
          <strong>exclusive only</strong> to you and does not allow for you to
          appoint an individual to act on your behalf as a user under your
          profile.
        </li>

        <li>
          <strong className='block mb-2'>USE OF THE PORTAL</strong>
          <ol className='list-small-roman'>
            <li>
              You may use the portal to request and/or apply for a Government
              Service virtually.
            </li>
            <li>
              You may not use any automatic device, program, algorithm, or
              methodology, or any similar or equivalent manual process, to
              access, acquire, copy or monitor any portion of the Portal or any
              content or in any way reproduce or circumvent the navigational
              structure or presentation of the Portal or any content, to obtain
              or attempt to obtain any materials, documents or information
              through any means not purposely made available through the Portal.
              GoBh reserves the right to prohibit any such activity.
            </li>
            <li>
              You may not attempt to gain unauthorized access to any portion or
              feature of the Portal, or any other system(s) or network(s)
              connected to the Portal or to any server, or to any of the
              services offered on or through the Portal, by hacking, password
              "mining" or any other illegitimate means.
            </li>
            <li>
              You may not probe, scan, or test the vulnerability of the Portal
              or any network connected to the Portal, nor breach the security or
              authentication measures on the Portal or any network connected to
              the Portal.
            </li>
            <li>
              You may not exploit the Portal, or any service or information made
              available or offered by or through the Portal, including but not
              limited to personal identification or information, other than your
              own information.
            </li>
            <li>
              You may not use the Portal or any related content for any purpose
              that is unlawful or prohibited by these Terms of Use, or to
              solicit the performance of any illegal activity or other activity.
            </li>
          </ol>
        </li>

        <li>
          <strong className='block mb-2'>
            ACCOUNTS, PASSWORDS AND SECURITY
          </strong>
          <ol className='list-small-roman'>
            <li>
              Certain features or services offered on or through the Portal will
              require you to set up an account (including the use of a valid,
              secured email address) and provide your mobile phone number for
              the purpose of authenticating your identity by using a one-time
              password (“OTP”). The OTP will be transmitted through the short
              message service (“SMS”) by the GoBh to your mobile number and to
              your email address. You will be required to input the OTP
              (wherever and whenever applicable that you are prompted and
              requested to do so) when you use the Portal to access any service.
            </li>
            <li>
              You must ensure that your mobile phone number is able to receive
              text messages and you will be responsible for any fee(s) imposed
              by your mobile phone service provider.
            </li>
            <li>
              You must not disclose to a third party the OTP that is transmitted
              to your mobile phone number, and you must ensure that your mobile
              phone number is protected from unauthorized use by any third
              parties.
            </li>
            <li>
              You must ensure that your username and passwords required to
              access the Portal are kept secure and confidential. Your username
              and password issued to you must not be shared. You are entirely
              responsible for maintaining the confidentiality of the information
              you hold for your account, including your password.
            </li>
            <li>
              You accept liability for any and all activity that occurs under
              your account as a result of your failing to keep this information
              secure and confidential. You agree to notify GoBh immediately
              where you suspect any unauthorized use of your account or
              password, or any other breach of security.
            </li>
            <li>
              You must not attempt to undermine the security or integrity of the
              Portal; use, or misuse, the Portal in any way which may impair the
              Portal or impair the ability of any other user to use the Portal,
              including using the Portal in a malicious, fraudulent or unlawful
              manner; attempt to gain unauthorized access; attempt to modify,
              copy, adapt, reproduce, disassemble, decompile or reverse engineer
              any aspect of the Portal.
            </li>
          </ol>
        </li>

        <li>
          <strong className='block mb-2'>YOUR OBLIGATIONS</strong>
          <ol className='list-smal-roman'>
            <li>
              You should only access the Portal for your own lawful purposes
              connected with requesting and/or receiving Government Services or
              utilizing any of the functions provided by the Portal and intended
              for your use.
            </li>
            <li>
              You are required to take all necessary actions to protect the
              confidentiality of your login information.
            </li>
            <li>
              You agree that GoBh may review Your use of the Portal at any time,
              and You will provide any reasonable assistance to verify Your
              compliance with this Agreement.
            </li>
            <li>
              If You use any communication tools available through the Portal
              (such as a message board), You agree only to use such
              communication tools for lawful and legitimate purposes. You must
              not use any such communication tool for posting or disseminating
              any material unrelated to the use of the Portal, and in particular
              to use non-verbal language that may be seen as pervasive
              intimidating, hostile or offensive and/or unsolicited commercial
              e-mail, or files.
            </li>
            <li>
              You agree and acknowledge that You are responsible for ensuring
              the accuracy of Data inputted into the Portal by You (including
              but not limited to your mobile phone number). GoBh is under no
              obligation to ensure that Your Data in the Portal is accurate.
            </li>
            <li>
              You agree and acknowledge that You are responsible for updating
              your information in the Portal where changes may occur. For
              example, name change, change of mobile phone number, changes in
              address. GoBh may not be under an obligation to ensure that Your
              Data is updated when changes occur. Your failure to provide any
              required information may result in your inability to access any
              service on the Portal.
            </li>
          </ol>
        </li>

        <li>
          <strong className='block mb-2'>CONFIDENTIALITY AND PRIVACY</strong>
          <ol className='list-small-roman'>
            <li>
              Unless the relevant party has the prior written consent of the
              other or unless required to do so by law each party will preserve
              the confidentiality of all Confidential Information obtained in
              connection with these Terms. Neither party will, without the prior
              written consent of the other, disclose or make any Confidential
              Information available to any person, or use the same for its own
              benefit, other than as expressly contemplated by these Terms
              and/or to provide the requested Government Service.
            </li>
            <li>
              GoBh will maintain a privacy policy that sets out what information
              will be collected and why, what GoBh does with that information,
              and how the information is handled. You should read the Privacy
              Policy posted on the Portal.
            </li>
            <li>
              For the purposes of abiding by the Data Protection (Privacy of
              Personal Information) Act, 2003 you agree that this Terms of Use
              and the accompanying Privacy Policy is understood as a
              determination between you and the GoBh for the manner in which any
              personal data will be processed.
            </li>
            <li>
              The GoBh, however, is authorized by you to use the data you
              provide for any additional Government Service. You grant GoBh the
              permission to use, copy, transmit, store, and back-up Your Data
              for the purposes of enabling You to access and use Government
              Services and for any other purpose related to the provision of
              Government Services to You, and matters ancillary thereto by
              prescribed technologies.
            </li>
          </ol>
        </li>

        <li>
          <strong className='block mb-2'>DUTY TO DISCLOSE</strong>
          GoBh may disclose any information we have about you (including your
          identity) if we determine that such disclosure is necessary in
          connection with any investigation or complaint regarding your use of
          the Portal, or to identify, contact or bring legal action against
          someone who may be causing injury to or interference with (either
          intentionally or unintentionally) the rights or property of the GoBh.
          GoBh is under a statutory duty to disclose any information deemed
          necessary in order to comply with any applicable law, regulation, or
          court process.
        </li>

        <li>
          <strong className='block mb-2'>INTELLECTUAL PROPERTY</strong>
          <ol className='list-small-roman'>
            <li>
              All text, graphics, user interfaces, visual interfaces,
              photographs, trademarks, logos, sounds, music, artwork and
              computer code (collectively referred to as "Content"), including
              but not limited to the design, structure, selection, coordination,
              expression, "look and feel" and arrangement of such Content,
              contained on the Portal is owned and/or controlled by the GoBh,
              and is protected by intellectual property rights and laws.
            </li>
            <li>
              Except where expressly provided in these Terms of Use, no part of
              the Portal and no Content may be copied, reproduced, republished,
              uploaded, posted, publicly displayed, encoded, translated,
              transmitted or distributed in any way (including "mirroring") to
              any other computer, server, Portal or other medium for publication
              or distribution without the express permission of the GoBh.
            </li>
          </ol>
        </li>

        <li>
          <strong className='block mb-2'>DELETION OF DATA</strong>
          Should you choose to discontinue using the Portal or GoBh otherwise
          suspends and/or terminate Your access to the Portal, GoBh in its
          discretion reserves the right, to either (a) delete Your data or (b)
          archive Your data for a period of time as designated by the Public
          Records Act, 1971 or such legislation that may seek to repeal, amend
          or replace same.
        </li>

        <li>
          <strong className='block mb-2'>
            ACKNOWLEDGEMENTS AND DISCLAIMERS
          </strong>
          <ol className='list-small-roman'>
            <li>
              You acknowledge and agree that GoBh gives no warranty about the
              Portal and, without limiting the foregoing, GoBh does not warrant
              that the use of the Portal will be uninterrupted or error free.
              Among other things, the operation and availability of the systems
              used for accessing the Portal, including telephone services,
              computer networks and the Internet, can be unpredictable and may
              from time to time interfere with or prevent access to the Portal.
              GoBh is not in any way responsible for any such interference or
              prevention of Your access or use of the Portal.
            </li>
            <li>
              All information provided on the portal is subject to change
              without notice.
            </li>
            <li>
              GoBh disclaims any and all liability for the acts, omissions and
              conduct of any third parties in connection with or related to your
              use of the Portal, including any loss, damages or expenses of any
              kind incurred or suffered by you arising from or in connection
              with any failure, delay or interruption in transmission, including
              the transmission of OTPs and SMS messaging or any suspension or
              unavailability of the same due to any failure of your mobile
              service network or any other force majeure events such as matters
              which are beyond our reasonable control.
            </li>
            <li>
              GoBh is not liable for any indirect, special, incidental,
              consequential, punitive or exemplary loss or damages, including
              loss of profits, loss of business, loss due to business
              interruption or loss of any software programme or hardware
              equipment or data in your mobile device or computer equipment and
              their systems.
            </li>
            <li>
              GoBh reserves the right to do any of the following, at any time:
              without notice to You, modify, suspend or terminate operation of
              or access to the Portal, or any portion of the Portal, for any
              reason and to interrupt the operation of the Portal, or any
              portion of the Portal, as necessary to perform routine or
              non-routine maintenance, error correction, or other changes.
            </li>
          </ol>
        </li>

        <li>
          <strong className='block mb-2'>LIMITATION OF LIABILITY</strong>
          You agree to indemnify GoBh against all losses (direct or
          consequential) that may incur arising out of or in connection with
          Your breach of any of these Terms.
        </li>

        <li>
          <strong className='block mb-2'>
            GENERAL DATA PROTECTION RULES (GDPR) UNDERTAKING
          </strong>
          The Government of The Bahamas is currently upgrading its laws to
          ensure compliance with the General Data Protection Rules (GDPR).
          Individuals who are subject to the GDPR mandate should review and
          fully understand the Terms of Use and Privacy Statement and are
          encouraged to consult with the applicable laws of their respective
          member country before proceeding.
        </li>

        <li>
          <strong className='block mb-2'> GENERAL</strong>
          These Terms, together with the Privacy Policy constitute the entire
          agreement between You and GoBh relating to the use of the Web Portal
          and the other matters dealt with in these Terms.
        </li>

        <li>
          <strong className='block mb-2'>HELP DESK</strong>
          You are entitled to technical support. GoBh will endeavour to address
          all queries and requests for assistance received via email at{' '}
          <a href='mailto:mygateway@bahamas.gov.bs'>
            mygateway@bahamas.gov.bs
          </a>{' '}
          but does not warrant that support will be immediately available.
        </li>

        <li>
          <strong className='block mb-2'>GOVERNING LAW</strong>
          You agree that all matters relating to your access to or use of the
          Portal, including all disputes, will be governed by the laws of the
          Commonwealth of The Bahamas.
        </li>
      </ol>

      <div className='flex justify-center mt-12'>
        <button className='btn custom-btn' onClick={history.goBack}>
          Go Back
        </button>
      </div>
    </section>
  )
}

export default TermsOfUse
